if (!customElements.get('bag-pack-options')) {
  customElements.define(
    'bag-pack-options',
    class BagPackOptions extends HTMLElement {
      connectedCallback() {
        this.units = parseInt(this.dataset.units, 10) || 0;
        this.fields = this.querySelector('[data-fields]');
        this.counter = this.querySelector('[data-count]');
        this.notice = this.querySelector('.pack-options-notice');
        this.noticeText = this.querySelector('[data-notice]');

        this.onClick = this.onClick.bind(this);
        this.onSubmitClick = this.onSubmitClick.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange.bind(this));

        // Los botones de agregar viven fuera de este elemento (ficha y barra
        // fija), asi que se vigilan desde el documento.
        document.addEventListener('click', this.onSubmitClick, true);

        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onSubmitClick, true);
      }

      get total() {
        return Array.from(this.querySelectorAll('.pb-qty__input')).reduce(
          (sum, input) => sum + (parseInt(input.value, 10) || 0),
          0
        );
      }

      onClick(event) {
        const step = event.target.closest('.pb-qty__step');
        if (!step) return;

        const input = step.parentElement.querySelector('.pb-qty__input');
        const current = parseInt(input.value, 10) || 0;
        const others = this.total - current;
        const next = current + parseInt(step.dataset.step, 10);

        input.value = Math.max(0, Math.min(next, this.units - others));
        this.refresh();
      }

      onChange(event) {
        if (!event.target.classList.contains('pb-qty__input')) return;

        const current = parseInt(event.target.value, 10) || 0;
        const others = this.total - current;
        event.target.value = Math.max(0, Math.min(current, this.units - others));
        this.refresh();
      }

      refresh() {
        const total = this.total;
        const missing = this.units - total;

        if (this.counter) this.counter.textContent = total;

        this.querySelectorAll('[data-step="1"]').forEach((step) => {
          step.disabled = total >= this.units;
        });

        this.classList.toggle('bag-pack--complete', missing === 0);
        if (missing === 0) this.notice?.setAttribute('hidden', '');

        // El ahorro solo tiene sentido mostrarlo con el pack completo.
        this.querySelector('.bag-pack__saving')?.toggleAttribute('hidden', missing !== 0);

        this.syncFields();
      }

      // Un campo oculto por sabor elegido, enganchado al formulario del producto.
      syncFields() {
        this.fields.innerHTML = '';

        this.querySelectorAll('.pb-flavor').forEach((flavor) => {
          const quantity = parseInt(flavor.querySelector('.pb-qty__input').value, 10) || 0;
          if (quantity === 0) return;

          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = `properties[${flavor.dataset.flavor}]`;
          field.value = quantity;
          field.setAttribute('form', this.dataset.form);
          this.fields.appendChild(field);
        });
      }

      onSubmitClick(event) {
        const button = event.target.closest?.('button[type="submit"]');
        if (!button) return;

        // Ojo: form.id devuelve el campo <input name="id">, no el identificador.
        const form = button.form || document.getElementById(button.getAttribute('form') || '');
        if (!form || form.getAttribute('id') !== this.dataset.form) return;

        const missing = this.units - this.total;
        if (missing <= 0) return;

        event.preventDefault();
        event.stopPropagation();

        if (this.noticeText && this.dataset.remainingLabel) {
          this.noticeText.textContent = this.dataset.remainingLabel.replace('[n]', missing);
        }
        this.notice?.removeAttribute('hidden');

        const top = window.scrollY + this.getBoundingClientRect().top - 120;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }
    }
  );
}

// aviso de ahorro 2026-08-22
